import { api } from './api';

class AdminService {
    async getDashboardAnalytics() {
        return api.get('/api/admin/analytics/dashboard');
    }

    async getUsers(params) {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/api/admin/users?${queryString}`);
    }

    async getVendors(params) {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/api/admin/vendors?${queryString}`);
    }

    async getServices(params) {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/api/admin/services?${queryString}`);
    }

    async getLiveJobs() {
        return api.get('/api/admin/live-jobs');
    }

    async getDriverLocations() {
        const data = await api.get('/api/admin/drivers/locations');
        return Array.isArray(data) ? data : data?.items || [];
    }
}

export const adminService = new AdminService();